import React from "react";
import { motion } from "framer-motion";

const data = [
  {
    id: 1,
    title: "The Circle of Nine",
    text: "You are never alone. A synchronized team of 9 medical experts—from Gynecologist to Nutritionists to Mental Health Coaches—surrounds you from Day 1. No more fragmented advice; just one cohesive, integrated, synced family of care.",
    img: "/beyond1.png",
    top: "15%",
    right: "10%",
    flexDir: "row-reverse",
    slideFrom: 150 
  },
  {
    id: 2,
    title: "The Pulse of AI",
    text: "Your health doesn't sleep, and neither does our technology. Our AI-driven daily health tracker tracks your vitals daily, detecting risks like GDM or Hypertension before they become complications.",
    img: "/beyond2.png",
    top: "38%",
    left: "10%",
    flexDir: "row",
    slideFrom: -150 
  },
  {
    id: 3,
    title: "The 24/7 Virtual Sanctuary",
    text: "Convenience is our clinical standard. No more 2 AM Google searches or rushed 10-minute clinic visits or long waiting hours at clinics. Your medical team is in your pocket, ready to treat, answer, guide, and reassure—anytime, anywhere.",
    img: "/beyond3.png",
    top: "60%",
    right: "12%",
    flexDir: "row-reverse",
    slideFrom: 150
  },
  {
    id: 4,
    title: "The Holistic Blueprint",
    text: "We care for the woman, not just the patient. With live Yoga, personalized Diet plans, Garbhasanskar, and Emotional Wellness tracking, we ensure your pregnancy is as much a celebration as it is a medical journey.",
    img: "/beyond4.png",
    top: "82%",
    left: "15%",
    flexDir: "row",
    slideFrom: -150
  },
];

const BeyondClinic = () => {
  return (
    <>

      <section className="beyond-section">
        <img src="/Beyondtop.png" className="top-edge" alt="" />
        <div className="beyond-header">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ amount: 0.5 }}
          >
           <h2>
             Beyond the <span className="pink-text">Clinic</span>. Beyond the <br />
             <span className="pink-text">Ordinary</span>
           </h2>
           <p>
             While hospitals focus on the delivery, Myprega focuses on you—every single hour, for all nine 
             months. This is how we’ve reimagined motherhood for the modern woman.
           </p>
          </motion.div>
        </div>

        <div className="road-wrapper">
          {data.map((item) => (
            <motion.div 
              key={item.id} 
              className="road-item" 
              style={{ 
                top: item.top, 
                left: item.left || 'auto', 
                right: item.right || 'auto',
                flexDirection: item.flexDir 
              }}
              
              initial={{ opacity: 0, x: item.slideFrom }} 
              whileInView={{ opacity: 1, x: 0 }} 
              viewport={{ amount: 0.3 }} 
              transition={{ duration: 0.7, ease: "easeOut" }}
            >
              <img src={item.img} alt={item.title} />
              <div className="item-text">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
        <img src="/BeyondbottoM.png" className="bottom-edge" alt="" />
      </section>
    </>
  );
};

export default BeyondClinic;
